document.addEventListener("DOMContentLoaded", function () {
  const collectionSwatches = document.querySelectorAll(".collection__swatch");
  collectionSwatches.forEach((element) =>
    element.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const swatchesRow = e.currentTarget.closest(".collection__swatches");
      swatchesRow.querySelectorAll(".collection__swatch").forEach((swatch) => {
        swatch.classList.remove("is-active");
        swatch.setAttribute("aria-pressed", "false");
      });
      e.currentTarget.classList.add("is-active");
      e.currentTarget.setAttribute("aria-pressed", "true");

      const tileLink = e.currentTarget.closest("a");
      if (e.currentTarget.dataset.image) {
        const image = tileLink.querySelector(".collection__link img");
        image.src = e.currentTarget.dataset.image;
        image.dataset.src = e.currentTarget.dataset.image;
      }

      const url = new URL(tileLink.href);
      url.searchParams.set("color", e.currentTarget.dataset.color);
      tileLink.href = url.toString();

      sendGA(
        "Color Swatch",
        "Color Swatch Interaction",
        e.currentTarget.dataset.gaLabel,
      );
    }),
  );
});
